<template>
    <div>
        <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
        <v-dialog v-model="ItemDialog" max-width="1000px">
            <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template> -->
            <v-card>
                <v-card-title>
                    <span class="headline">Role Based Workflow Item</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="9">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('columns.company')"
                                    type="text"
                                    ref = "compnyname"
                                    clearable
                                    :items="companyList"
                                    v-model="selections[0].compnyid"
                                    @change="changeCompanyHandler(selections[0].compnyid)"
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3">
                                <v-text-field
                                    outlined
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].compnycode"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.branch')"
                                    type="text"
                                    ref="brchname"
                                    dense
                                    :items="branchList"
                                    v-model="selections[0].branchid"
                                    @change="
                                        changeBranchHandler(
                                            selections[0].branchid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].brchcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.division')"
                                    type="text"
                                    ref="divnname"
                                    dense
                                    :items="divisionList"
                                    v-model="selections[0].divisionid"
                                    @change="
                                        changeDivisionHandler(
                                            selections[0].divisionid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].divncode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.department')"
                                    type="text"
                                    ref="deptname"
                                    dense
                                    :items="departmentList"
                                    v-model="selections[0].deptid"
                                    @change="
                                        changeDepartmentHandler(
                                            selections[0].deptid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].deptcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.section')"
                                    type="text"
                                    ref="sectioname"
                                    dense
                                    :items="sectionList"
                                    v-model="selections[0].sectionid"
                                    @change="
                                        changeSectionHandler(
                                            selections[0].sectionid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].sectiocode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.unit')"
                                    type="text"
                                    ref="unitname"
                                    dense
                                    :items="unitList"
                                    v-model="selections[0].unitid"
                                    @change="
                                        changeUnitHandler(
                                            selections[0].unitid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].unitcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.grade')"
                                    type="text"
                                    ref="grddesc"
                                    dense
                                    :items="gradeList"
                                    v-model="selections[0].gradeid"
                                    @change="
                                        changeGradeHandler(
                                            selections[0].gradeid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3"  class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].grdcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.job')"
                                    type="text"
                                    ref="jobtitle"
                                    dense
                                    :items="jobList"
                                    v-model="selections[0].jobid"
                                    @change="
                                        changeJobHandler(
                                            selections[0].jobid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].jobcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    clearable
                                    :label="this.$t('columns.employmenttype')"
                                    type="text"
                                    ref="emptypedesc"
                                    dense
                                    :items="emptypeList"
                                    v-model="selections[0].emptypeid"
                                    @change="
                                        changeEmpTypeHandler(
                                            selections[0].emptypeid
                                        )
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="this.$t('columns.code')"
                                    type="text"
                                    v-model="selections[0].emptype"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="'Approval Levels'"
                                    type="text"
                                    clearable
                                    :items="levelList"
                                    :rules="[rules.requiredd]"
                                    v-model="selections[0].levelno"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="'Email Notification'"
                                    type="text"
                                    clearable
                                    :items="emailList"
                                    :rules="[rules.requiredd]"
                                    v-model="selections[0].IsEmail"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('setupapprvlworkflow.firstreminderhour')"
                                    type="number"
                                    clearable
                                    :rules="[rules.requiredd]"
                                    v-model="selections[0].remindone"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('setupapprvlworkflow.subsequentreminderhours')"
                                    type="number"
                                    clearable
                                    :rules="[rules.requiredd]"
                                    v-model="selections[0].remindnext"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="4" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('setupapprvlworkflow.maxreminder')"
                                    type="number"
                                    clearable
                                    :rules="[rules.requiredd]"
                                    v-model="selections[0].maxreminder"
                                    dense
                                    placeholder="Enter 0 for unlimited reminders"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="8" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupapprvlworkflow.dueaction')"
                                    type="text"
                                    clearable
                                    :items="wfdueactionList"
                                    :rules="[rules.required]"
                                    v-model="selections[0].wfdueactionid"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="'Days'"
                                    type="number"
                                    clearable
                                    v-model="selections[0].days"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="'Amount'"
                                    type="number"
                                    clearable
                                    v-model="selections[0].amount"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                            <v-col cols="8" sm="5" class="mt-n8">
                                <v-checkbox
                                    :label="this.$t('setupapprvlworkflow.emailnoti')"
                                    v-model="selections[0].IsEmail"
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" sm="5" class="mt-n8">
                                <v-checkbox
                                    :label="this.$t('setupapprvlworkflow.autoapproved')"
                                    v-model="selections[0].IsAutoapr"
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" sm="5" class="mt-n8">
                                <v-checkbox
                                    :label="this.$t('setupapprvlworkflow.onlyhrapproval')"
                                    v-model="selections[0].IsHronly"
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" sm="5" class="mt-n8">
                                <v-checkbox
                                    :label="this.$t('setupapprvlworkflow.hrasfinalapprover')"
                                    v-model="selections[0].IsHrlast"
                                ></v-checkbox>
                            </v-col>
                        </v-row> -->
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{
                        errMsg
                    }}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1" 
                        text @click="closeCRUD"
                        >{{$t('button.cancel')}}</v-btn>

                    <v-btn 
                        color="green darken-1" 
                        text 
                        @click="saveItems"
                        >{{$t('button.save')}}</v-btn>

                    <!-- <v-btn
                        v-else
                        disabled
                        color="green darken-1"
                        text
                        @click="saveItems"
                        >Save</v-btn> -->

                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="RoleLevelDialog" max-width="800px">
            <v-card>
            <v-card-title>
                <span class="headline">Role Based - Add Workflow Role</span>
                <v-spacer></v-spacer>
                <v-btn v-if="!isRoleLevelEnough"
                color="primary" dark class="mb-2" @click.stop="addRoleLevel">+</v-btn>
                <v-btn class="ml-4 mb-2" icon @click="RoleLevelDialog = false">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-container>
                <v-row v-for="(role, index) in roleLevelList.filter(r => r.wfsetupdid === RoleSetupId)" :key="index">
                    <v-col cols="12">
                    <v-card class="mb-4">
                        <v-card-text>
                        <!-- Level No -->
                        <v-row>
                            <v-col cols="3">
                            <v-label>Level No</v-label>
                            </v-col>
                            <v-col cols="8">
                            <span style="font-weight: bold">{{ role.levelNo }}</span>
                            </v-col>
                            <v-col cols="1">
                            <v-icon small @click="modifyRole(role)">mdi-pen</v-icon>
                            </v-col>
                        </v-row>

                        <!-- Primary Role -->
                        <v-row class="mt-n4">
                            <v-col cols="3">
                            <v-label>Primary Role</v-label>
                            </v-col>
                            <v-col cols="9">
                            <span style="font-weight: bold">{{ role.primaryRoleText }}</span>
                            </v-col>
                        </v-row>

                        <!-- Secondary Role -->
                        <v-row class="mt-n4">
                            <v-col cols="3">
                            <v-label>Secondary Role</v-label>
                            </v-col>
                            <v-col cols="9">
                            <span style="font-weight: bold">{{ role.secondaryRoleText }}</span>
                            </v-col>
                        </v-row>

                        <!-- Mechanism -->
                        <v-row class="mt-n4">
                            <v-col cols="3">
                            <v-label>Mechanism</v-label>
                            </v-col>
                            <v-col cols="9">
                            <span style="font-weight: bold">{{ role.mechanismText }}</span>
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="AddRoleLevelDialog" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Role Based - Add Details</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="3">
                                <v-autocomplete
                                    outlined
                                    :label="'Level No'"
                                    type="text"
                                    :items="LevelNoList"
                                    v-model="newRole.levelNo"
                                    :rules="[rules.required]"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n8">
                            <v-col cols="9">
                                <v-autocomplete
                                    outlined
                                    :label="'Primary Role'"
                                    type="text"
                                    :items="availablePrimaryRoles"
                                    v-model="newRole.primaryRole"
                                    @change="changePrimaryRoleHandler"
                                    :rules="[rules.required]"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    outlined
                                    :label="'Code'"
                                    type="text"
                                    v-model="newRole.primaryRoleCode"
                                    dense
                                    background-color="#ffeab2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n8">
                            <v-col cols="9">
                                <v-autocomplete
                                    outlined
                                    :label="'Secondary Role'"
                                    type="text"
                                    :items="availableSecondaryRoles"
                                    v-model="newRole.secondaryRole"
                                    @change="changeSecondaryRoleHandler"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    outlined
                                    :label="'Code'"
                                    type="text"
                                    v-model="newRole.secondaryRoleCode"
                                    dense
                                    background-color="#ffeab2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n8">
                            <v-col cols="9">
                                <v-autocomplete
                                    outlined
                                    :label="'Mechanism'"
                                    type="text"
                                    :items="mechanismList"
                                    v-model="newRole.mechanism"
                                    @change="changeMechanismHandler"
                                    :rules="[rules.required]"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    outlined
                                    :label="'Code'"
                                    type="text"
                                    v-model="newRole.mechanismCode"
                                    dense
                                    background-color="#ffeab2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1" 
                        text @click="closeRoleLevel"
                        >{{$t('button.cancel')}}</v-btn>

                    <v-btn 
                        color="green darken-1" 
                        text 
                        @click="saveRoleLevel(LevelNoList)"
                        >{{$t('button.save')}}</v-btn>

                    <!-- <v-btn
                        v-else
                        disabled
                        color="green darken-1"
                        text
                        @click="saveItems"
                        >Save</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>


        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="this.detailItem"
            class="elevation-1"
:sort-by="['code']"
            >
            <template v-slot:item.action="{ item }">
                <div class="d-flex align-center">
                    <img 
                        :src="`${publicPath}images/paper.svg`" 
                        alt="SVG Icon" 
                        @click="onAdvanceEditItem(item)" 
                        style="width: 15px; height: 18px; cursor: pointer;"
                        class="mb-1"
                    />
                    <v-icon
                        small
                        class="ml-2 mr-2"
                        @click="modifyItemHandler(item)"
                    >
                        mdi-pen
                    </v-icon>
                    <v-icon
                        small
                        class="mr-2"
                        @click="deleteItemHandler(item)"
                    >
                        mdi-delete
                    </v-icon>
                </div>
            </template>
        </v-data-table>
        </div>

        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isSuccess">
            <app-success v-bind:parentObject="{
                isSuccess: this.isSuccess,
                messageSuccess: this.messageSuccess,
            }"
            v-on:close-success="isSuccess = false"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
            }"
            v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>

</template>

<script>
import compareArray from "../../../util/comparearray";
import ErrorDialog from "../../../components/common/ErrorDialog";
import SuccessDialog from "../../../components/common/SuccessDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-success": SuccessDialog
    },

    computed: {
        // Computed property to filter out selected roles for the primary role dropdown
        availablePrimaryRoles() {
            return this.roleList.filter(role => role.value !== this.newRole.secondaryRole);
        },

        // Computed property to filter out selected roles for the secondary role dropdown
        availableSecondaryRoles() {
            return this.roleList.filter(role => role.value !== this.newRole.primaryRole);
        },
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                requiredd: value => this.validate(value) || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || this.$t('reportsparam.invalidemail');
                }
            },

            publicPath: process.env.BASE_URL,

            ItemDialog: false,
            RoleLevelDialog: false,
            AddRoleLevelDialog: false,
            detailItem: this.parentObject.detailItem,
            wftypeid: null,
            detailid: null,
            //Selections
            selections: [
                {
                    id: null,
                    wfsetupid: parseInt(this.$route.params.id),
                    branchid: null,
                    brchcode: null,
                    brchname: null,
                    divisionid: null,
                    divncode: null,
                    divnname: null,
                    deptid: null,
                    deptcode: null,
                    deptname: null,
                    sectionid: null,
                    sectiocode: null,
                    sectioname: null,
                    unitid: null,
                    unitcode: null,
                    unitname: null,
                    gradeid: null,
                    grdcode: null,
                    grddesc: null,
                    jobid: null,
                    jobcode: null,
                    jobtitle: null,
                    emptypeid: null,
                    emptype: null,
                    emptypedesc: null,
                    levelno: null,
                    compnyid: null,
                    compnycode: null,
                    compnyname : null,
                    autoapr: "",
                    IsAutoapr: false,
                    email: "",
                    IsEmail: true,
                    hronly: "",
                    IsHronly: false,
                    hrlast: "",
                    IsHrlast: false,
                    remindone: null,
                    remindnext: null,
                    maxreminder: null,
                    wfdueactionid: null,
                    wfdueaction: null,
                    days: null,
                    amount: null,
                    rectimestamp: null,
                    updatedby: null,
                    stamp: 0,
                    action: 0
                }
            ],

            isRoleLevelEnough: false,

            newRole: {
                id: null,
                wfsetupdid: null,
                levelNo: null,
                primaryRole: null,
                primaryRoleCode: null,
                secondaryRole: null,
                secondaryRoleCode: null,
                mechanism: null,
                mechanismCode: null,
                rectimestamp: null,
                updatedby: this.$store.getters.userId,
                stamp: 0,
            },

            roleList: [],
            roleItems: [],
            LevelNoList: [],

            mechanismList: [],
            mechanismItems: [],

            roleLevelList: [],
            roleLevelItems: [],
            isEditRoleLevel: false,
            RoleSetupId: null,

            companies: [],
            wfdueactions: [],

            //Lists
            companyList: [],
            branchList: [],
            branchItems: [],
            divisionList: [],
            divisionItems: [],
            departmentList: [],
            departmentItems: [],
            sectionList: [],
            sectionItems: [],
            unitList:[],
            unitItems:[],
            emptypeList: [],
            emptypeItems: [],
            gradeList: [],
            gradeItems: [],
            jobList: [],
            jobItems: [],
            emailList: [
                { text: 'Yes', value: true },
                { text: 'No', value: false }
            ],
            
            detailList: [],
            selected: [],

            levelList: [],
            wfdueactionList: [],

            modify: false,
            isConfirm: false,

            tmpDetailItem: null,
            oItem: null,
            allowSave:false,
            withDuplicates: false,
            isDupItem: false,

            isNew: false,
           // isConfirm: false,
            confirmDelete: false,
            isSuccess: false,
            messageSuccess: '',

            isExisting: false,
            isErr: false,
            errMsg: "",
        };
    },

    methods: {
        modifyRole(role){
            this.newRole = {
                id: role.id,
                wfsetupdid: role.wfsetupdid,
                levelNo: role.levelNo,
                primaryRole: role.primaryRole,
                primaryRoleCode: role.primaryRoleCode,
                secondaryRole: role.secondaryRole,
                secondaryRoleCode: role.secondaryRoleCode,
                mechanism: role.mechanism,
                mechanismCode: role.mechanismCode,
                rectimestamp: null,
                updatedby: this.$store.getters.userId,
                stamp: 0,
            };
            this.AddRoleLevelDialog = true;
            this.isEditRoleLevel = true;
        },

        saveRoleLevel(LevelNoList){
            const vm = this;
            console.log("LEVELLIST",LevelNoList.length);
            if(!vm.isEditRoleLevel){ //ADD
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                this.$store.dispatch('post', {url: "/rolelevel/create", payload: this.newRole})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        //Then add to array 
                        this.roleLevelList.push({
                            id: res.data.insertId,
                            wfsetupdid: this.newRole.wfsetupdid,
                            levelNo: this.newRole.levelNo,
                            primaryRole: this.newRole.primaryRole,
                            primaryRoleText: this.roleList.find(role => role.value === this.newRole.primaryRole)?.text || '', // Safely get primaryRoleText
                            primaryRoleCode: this.newRole.primaryRoleCode,
                            secondaryRole: this.newRole.secondaryRole,
                            secondaryRoleText: this.newRole.secondaryRole // Check if secondaryRole exists
                                ? this.roleList.find(role => role.value === this.newRole.secondaryRole)?.text || '' // Safely get secondaryRoleText
                                : '', // If secondaryRole doesn't exist, set to empty string
                            secondaryRoleCode: this.newRole.secondaryRoleCode,
                            mechanism: this.newRole.mechanism,
                            mechanismText: this.mechanismList.find(item => item.value === this.newRole.mechanism)?.text || '', // Safely get mechanismText
                            mechanismCode: this.newRole.mechanismCode
                        });

                        if(this.roleLevelList.filter(r => r.wfsetupdid === this.newRole.wfsetupdid).length >= LevelNoList.length){
                            this.isRoleLevelEnough = true;
                        }
                        this.AddRoleLevelDialog = false;
                        this.resetRoleSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }else{ //EDIT
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                this.$store.dispatch('put', {url: "/rolelevel/" + this.newRole.id, payload: this.newRole})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        const index = this.roleLevelList.findIndex(role => role.id === this.newRole.id);
                        if (index !== -1) {
                            this.roleLevelList.splice(index, 1, {
                                id: this.newRole.id,
                                wfsetupdid: this.newRole.wfsetupdid,
                                levelNo: this.newRole.levelNo,
                                primaryRole: this.newRole.primaryRole,
                                primaryRoleText: this.roleList.find(role => role.value === this.newRole.primaryRole)?.text || '',
                                primaryRoleCode: this.newRole.primaryRoleCode,
                                secondaryRole: this.newRole.secondaryRole,
                                secondaryRoleText: this.newRole.secondaryRole
                                    ? this.roleList.find(role => role.value === this.newRole.secondaryRole)?.text || ''
                                    : '',
                                secondaryRoleCode: this.newRole.secondaryRoleCode,
                                mechanism: this.newRole.mechanism,
                                mechanismText: this.mechanismList.find(item => item.value === this.newRole.mechanism)?.text || '',
                                mechanismCode: this.newRole.mechanismCode
                            });
                            this.AddRoleLevelDialog = false;
                            this.resetRoleSelections();
                        }
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }
        },

        closeRoleLevel() {
            this.AddRoleLevelDialog = false;
            this.resetRoleSelections();
        },

        changePrimaryRoleHandler(value) {
            const selectedRole = this.roleList.find(role => role.value === value);
            if (selectedRole) {
                this.newRole.primaryRole = selectedRole.value;
                this.newRole.primaryRoleCode = selectedRole.code;
            }
        },

        changeSecondaryRoleHandler(value) {
            const selectedRole = this.roleList.find(role => role.value === value);
            if (selectedRole) {
                this.newRole.secondaryRole = selectedRole.value;
                this.newRole.secondaryRoleCode = selectedRole.code;
            }
        },


        changeMechanismHandler(value) {
            let item = this.mechanismList.find(item => item.value === value);
            this.newRole.mechanismCode = item ? item.code : null;
        },

        compareArray,


        validate(value) {
            if(value == null){
                return false;
            }
            if(value > -1 && value < 6){
                return true;
            }
        },

         dupDetailItemHandler() {
             let origDetailItem = [...this.detailItem];
             let tmpDetailItem = [];

             origDetailItem.forEach((item) => {
                 tmpDetailItem.push({
                     id: item.id,
                     wfsetupid: item.wfsetupid,
                     levelno: item.levelno,
                     compnyid: item.compnyid,
                     autoapr: item.autoapr,
                     email: item.email,
                     hronly: item.hronly,
                     hrlast: item.hrlast,
                     remindone: item.remindone,
                     remindnext: item.remindnext,
                     maxreminder: item.maxreminder,
                     wfdueactionid: item.wfdueactionid,
                     wfdueaction: item.wfdueaction
                 });
             });

             return tmpDetailItem;
         },

        addRoleLevel(){
            this.RoleLevelDialog = false;
            this.AddRoleLevelDialog = true;
        },

        onAdvanceEditItem(item) {
            console.log(item);
            this.resetRoleSelections();
            this.RoleSetupId = item.id;

            // Generate the LevelNoList from 1 to item.levelno
            this.LevelNoList = Array.from({ length: item.levelno }, (_, i) => i + 1);

            // Check how many matching role levels exist for this item
            const matchingRoles = this.roleLevelList.filter(r => r.wfsetupdid === item.id);

            // Comparison
            if (matchingRoles.length >= item.levelno) {
                this.isRoleLevelEnough = true;
            } else {
                this.isRoleLevelEnough = false;
            }
            this.RoleLevelDialog = true;
            this.newRole.wfsetupdid = item.id;
        },

        modifyItemHandler(item) {

            this.isExisting = true; 
            
            // if (item.compnyid ) {
            //     this.allowSave = true
            // }

            // assign loaded data to selections array

            if(item.action == 1) {
                this.modify = true;
            }

             if(item.action == 2) {
                 this.isExisting = true;
             }
           
             if (item.email == "Y") {
                 item.IsEmail = true;
             }else {
                 item.IsEmail = false;
             }

              this.selections  = [{
                id: item.id,
                wfsetupid: item.wfsetupid,
                levelno: item.levelno,
                compnyid: item.compnyid,
                compnycode: item.compnycode,
                compnyname: item.compnyname,
                branchid: item.branchid,
                brchcode: item.brchcode,
                brchname: item.brchname,
                divisionid: item.divisionid,
                divncode: item.divncode,
                divnname: item.divnname,
                deptid: item.deptid,
                deptcode: item.deptcode,
                deptname: item.deptname,
                sectionid: item.sectionid,
                sectiocode: item.sectiocode,
                sectioname: item.sectioname,
                unitid: item.unitid,
                unitcode: item.unitcode,
                unitname: item.unitname,
                gradeid: item.gradeid,
                grdcode: item.grdcode,
                grddesc: item.grddesc,
                jobid: item.jobid,
                jobcode: item.jobcode,
                jobtitle: item.jobtitle,
                emptypeid: item.emptypeid,
                emptype: item.emptype,
                emptypedesc: item.emptypedesc,
                days: item.days,
                amount: item.amount,
                autoapr: item.autoapr,
                IsAutoapr: item.IsAutoapr,
                email: item.email,
                IsEmail: item.IsEmail,
                hronly: item.hronly,
                IsHronly: item.IsHronly,
                hrlast: item.hrlast,
                IsHrlast: item.IsHrlast,
                remindone: item.remindone,
                remindnext: item.remindnext,
                maxreminder: item.maxreminder,
                wfdueactionid: item.wfdueactionid,
                wfdueaction: item.wfdueaction,
                action: item.action
            }]
            
            // this.selections[0] = item;
            this.oItem = item.compnyid;
            // this.ItemDialog = true;
            //this.allowSave = true;
          

            this.openDialog();
        },


       checkDupItem(val) {
            if (this.tmpDetailItem.some((item) => item.compnyid == val)) {
                return true;
            }

            return false;
        },

        checkAllFields(){
            let currItemId = parseInt(this.selections[0].compnyid);

            if(this.selections[0].compnyid){
                let isDupItem = false;
               
               if (this.isExisting) {
                    // check item
                    if (this.oItem !== currItemId) {
                        isDupItem = this.checkDupItem(currItemId);

                        if (isDupItem) {
                            this.duplicateError("item");
                            return;
                        }
                    }

               } else {
                   isDupItem = this.checkDupItem(currItemId);

                    if (isDupItem) {
                        this.duplicateError("item");
                        return;
                    }
               }

               
            }
        },

        newItem() {
            // set the form to empty if it is new
            this.isNew = true;
            this.allowSave = false;

            if (this.isNew) {
                this.resetSelections();
            }

            this.openDialog();
        },

        
        deleteItemHandler(item) {
            const vm = this
            this.$store.dispatch('get', {url: `/wftranbyid/` + item.id, payload: vm.data})
            .then(res => {
                let wftranRecords  = res.data.rec;
                if (wftranRecords .length > 0) {
                    vm.isErr = true;
                    vm.errMsg = 'Cannot delete active workflow setup';
                    return false
                } else {
                    const itemIndex = this.detailItem.findIndex(i => i.id === item.id);
                    if (itemIndex !== -1) {
                        this.detailItem.splice(itemIndex, 1);
                    }
                    this.$emit("delete");
                    return true
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

               
        openDialog() {
            this.tmpDetailItem = this.dupDetailItemHandler();

            this.ItemDialog = true;
        },

        duplicateError(typeStr) {
            this.isErr = true;
            this.errMsg = "Duplicate " + typeStr + " not allowed";
            
            this.selections[0].compnyid = ''
            this.selections[0].compnyname = ''
            this.selections[0].compnycode = ''
        },

        closeCRUD() {

            this.resetSelections();

            this.ItemDialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            this.detailItem = [...this.detailItem];
        },

        saveItems() {
             if (this.selections[0].compnyid == null ) {
                 this.$dialog.alert(this.$t('fillinthecompanycolumn')).then((dialog) => {
                console.log(dialog);
             });
             }
             else if (this.selections[0].levelno == null ) {
                 this.$dialog.alert(this.$t('fillinnooflevelcolumn')).then((dialog) => {
                console.log(dialog);
             });
             }
              else if(this.selections[0].remindone == null) {
                 this.$dialog.alert(this.$t('fillinfirstreminderhour')).then((dialog) => {
                console.log(dialog);
             });}
             else if (this.selections[0].remindnext == null){
                 this.$dialog.alert(this.$t('fillinsubsequentreminderhour')).then((dialog) => {
                console.log(dialog);
             });
             } else if (this.selections[0].maxreminder == null ){

              this.$dialog.alert(this.$t('fillinmaxreminderhours')).then((dialog) => {
                console.log(dialog);
             });
            } else if (this.selections[0].wfdueactionid == null ){

              this.$dialog.alert(this.$t('fillindueactioncolumn')).then((dialog) => {
                console.log(dialog);
             });
            } else {
                this.isErr = false;
                
                this.wftypeid = this.parentObject.wftypeid
                this.detailid = this.parentObject.detailid

                

                // if ((this.selections[0].remindone > 0 && (this.selections[0].maxreminder < 1)) || 
                // (this.selections[0].remindone > 0 && this.selections[0].remindnext > 0 && (this.selections[0].maxreminder < 2))) {
                //     this.errMsg = this.$t('fieldmaxremindershouldbehigher');
                //     this.isErr = true;
                    
                //     return;

                // }

                if (this.selections[0].levelno == null) {
                    this.errMsg = this.$t('fieldnooflevelisrequired');
                    this.isErr = true;
                    
                    return;
                }

                if (this.selections[0].wfdueactionid == null) {
                    this.errMsg = this.$t('fielddueactionisrequired');
                    this.isErr = true;

                    return;
                }

                if (this.parentObject.wftypeid == 3 || this.parentObject.wftypeid == 7) {
                    const s = this.selections[0];
                    const field = this.parentObject.wftypeid == 3 ? 'days' : 'amount';
                    const isNoValue = s[field] === null || s[field] === '' || s[field] === undefined;
                    if (isNoValue) {
                        const existingNoValue = this.detailItem.some(item => {
                            if (this.isExisting && item.id === s.id) return false;
                            const itemNoValue = item[field] === null || item[field] === '' || item[field] === undefined;
                            if (!itemNoValue) return false;
                            return item.compnyid == s.compnyid &&
                                   item.branchid == s.branchid &&
                                   item.divisionid == s.divisionid &&
                                   item.deptid == s.deptid &&
                                   item.sectionid == s.sectionid &&
                                   item.unitid == s.unitid &&
                                   item.gradeid == s.gradeid &&
                                   item.jobid == s.jobid &&
                                   item.emptypeid == s.emptypeid;
                        });
                        if (existingNoValue) {
                            this.isErr = true;
                            const label = this.parentObject.wftypeid == 3 ? 'Days' : 'Amount';
                            const wfname = this.parentObject.wftypeid == 3 ? 'Leave Application' : 'Claim Application';
                            this.errMsg = `A record with the same combination and no ${label} value already exists for ${wfname} workflow.`;
                            return;
                        }
                    }
                }

                // The Email Notification dropdown only updates IsEmail (boolean); email (the
                // "Y"/"N" value actually persisted) is otherwise never synced from it, so a
                // changed selection here was being silently discarded on save.
                this.selections[0].email = this.selections[0].IsEmail ? "Y" : "N";

                console.log("SELECTIONS 0", this.selections[0]);

                if (this.isNew && !this.isExisting && !this.modify) {
                    this.detailItem.push(Object.assign({}, this.selections[0]));

                    for (let i = 0; i < this.detailItem.length; i++) {
                        if (this.detailItem[i].action == 0) {
                            this.detailItem[i].action = 1;
                        }
                    }

                    console.log("DETAIL ITEM1", this.detailItem);
                } else { 
                    this.detailItem.forEach((element) => {
                        if (element.id == this.selections[0].id) {
                            (element.wfsetupid = this.selections[0].wfsetupid),
                            (element.levelno = this.selections[0].levelno),
                            (element.compnyid = this.selections[0].compnyid),
                            (element.compnycode = this.selections[0].compnycode),
                            (element.compnyname = this.selections[0].compnyname),
                            (element.branchid = this.selections[0].branchid),
                            (element.brchcode = this.selections[0].brchcode),
                            (element.brchname = this.selections[0].brchname),
                            (element.divisionid = this.selections[0].divisionid),
                            (element.divncode = this.selections[0].divncode),
                            (element.divnname = this.selections[0].divnname),
                            (element.deptid = this.selections[0].deptid),
                            (element.deptcode = this.selections[0].deptcode),
                            (element.deptname = this.selections[0].deptname),
                            (element.sectionid = this.selections[0].sectionid),
                            (element.sectiocode = this.selections[0].sectiocode),
                            (element.sectioname = this.selections[0].sectioname),
                            (element.unitid = this.selections[0].unitid),
                            (element.unitcode = this.selections[0].unitcode),
                            (element.unitname = this.selections[0].unitname),
                            (element.gradeid = this.selections[0].gradeid),
                            (element.grdcode = this.selections[0].grdcode),
                            (element.grddesc = this.selections[0].grddesc),
                            (element.jobid = this.selections[0].jobid),
                            (element.jobcode = this.selections[0].jobcode),
                            (element.jobtitle = this.selections[0].jobtitle),
                            (element.emptypeid = this.selections[0].emptypeid),
                            (element.emptype = this.selections[0].emptype),
                            (element.emptypedesc = this.selections[0].emptypedesc),
                            (element.email = this.selections[0].email),
                            (element.remindone = this.selections[0].remindone),
                            (element.remindnext = this.selections[0].remindnext);
                            (element.maxreminder = this.selections[0].maxreminder),
                            (element.days = this.selections[0].days),
                            (element.amount = this.selections[0].amount),
                            (element.wfdueactionid = this.selections[0].wfdueactionid);
                            if (element.action !== 1) {
                                element.action = 2;
                            }
                        }
                    });
                    console.log("DETAIL ITEM2", this.detailItem);

                }

                let finalDetailItem = [...this.detailItem];

                console.log("FINALDETAILITEM", finalDetailItem);

                this.$emit("input", finalDetailItem);

                this.modify = false;
                this.isExisting = false;
                this.ItemDialog = false;
                this.messageSuccess = this.isNew ? 'Item has been added successfully.' : 'Item has been updated successfully.';
                this.isNew = false;
                this.isSuccess = true;
            }
        },

        resetSelections() {
            this.selections = [
                {
                    id: null,
                    wfsetupid: null,
                    levelno: null,
                    compnyid: null,
                    compnycode: null,
                    compnyname: null,
                    branchid: null,
                    brchcode: null,
                    brchname: null,
                    divisionid: null,
                    divncode: null,
                    divnname: null,
                    deptid: null,
                    deptcode: null,
                    deptname: null,
                    sectionid: null,
                    sectiocode: null,
                    sectioname: null,
                    unitid: null,
                    unitcode: null,
                    unitname: null,
                    gradeid: null,
                    grdcode: null,
                    grddesc: null,
                    jobid: null,
                    jobcode: null,
                    jobtitle: null,
                    emptypeid: null,
                    emptype: null,
                    emptypedesc: null,
                    autoapr: "",
                    IsAutoapr: false,
                    email: "",
                    IsEmail: false,
                    hronly: "",
                    IsHronly: false,
                    hrlast: "",
                    IsHrlast: false,
                    remindone: null,
                    remindnext: null,
                    maxreminder: null,
                    wfdueactionid: null,
                    wfdueaction: null,
                    days: null,
                    amount: null,
                    rectimestamp: null,
                    updatedby: null,
                    stamp: 0,
                    action: 0
                }
            ];
        },

        resetRoleSelections(){
            this.newRole = {
                id: null,
                wfsetupdid: null,
                levelNo: null,
                primaryRole: null,
                primaryRoleCode: null,
                secondaryRole: null,
                secondaryRoleCode: null,
                mechanism: null,
                mechanismCode: null,
                rectimestamp: null,
                updatedby: this.$store.getters.userId,
                stamp: 0,
            };
        },

        loadCompanies() {
            const vm = this;

            this.$store.dispatch('get', {url: "/company/notdisable"}).then(res => {
                vm.companies = res.data.rec;

                for (let i = 0; i < vm.companies.length; i++) {
                    vm.companyList.push({
                        text: vm.companies[i].compnyname,
                        code: vm.companies[i].compnycode,
                        value: vm.companies[i].id,
                    });
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        loadBranch(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/branch/notdisable'
            })
            .then(res => {

                vm.branchItems = res.data.rec;

                for (let i = 0; i < vm.branchItems.length; i++) {
                    vm.branchList.push({
                        text: vm.branchItems[i].brchname,
                        code: vm.branchItems[i].brchcode,
                        value: vm.branchItems[i].id,
                    });

                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadDivisionHandler(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/division/notdisable'
            })
            .then(res => {

                vm.divisionItems = res.data.rec;

                for (let i = 0; i < vm.divisionItems.length; i++) {
                    vm.divisionList.push({
                        text: vm.divisionItems[i].divnname,
                        code: vm.divisionItems[i].divncode,
                        value: vm.divisionItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadDepartment(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/department/notdisable'
            })
            .then(res => {

                vm.departmentItems = res.data.rec;

                for (let i = 0; i < vm.departmentItems.length; i++) {
                    vm.departmentList.push({
                        text: vm.departmentItems[i].deptname,
                        code: vm.departmentItems[i].deptcode,
                        value: vm.departmentItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadSection(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/section/notdisable'
            })
            .then(res => {

                vm.sectionItems = res.data.rec;

                for (let i = 0; i < vm.sectionItems.length; i++) {
                    vm.sectionList.push({
                        text: vm.sectionItems[i].sectioname,
                        code: vm.sectionItems[i].sectiocode,
                        value: vm.sectionItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadUnit(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/unit/notdisable'
            })
            .then(res => {

                vm.unitItems = res.data.rec;

                for (let i = 0; i < vm.unitItems.length; i++) {
                    vm.unitList.push({
                        text: vm.unitItems[i].unitname,
                        code: vm.unitItems[i].unitcode,
                        value: vm.unitItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadEmpType(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/emptype/notdisable'
            })
            .then(res => {

                vm.emptypeItems = res.data.rec;

                for (let i = 0; i < vm.emptypeItems.length; i++) {
                    vm.emptypeList.push({
                        text: vm.emptypeItems[i].emptypedesc,
                        code: vm.emptypeItems[i].emptype,
                        value: vm.emptypeItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadGrade(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/grade/notdisable'
            })
            .then(res => {

                vm.gradeItems = res.data.rec;

                for (let i = 0; i < vm.gradeItems.length; i++) {
                    vm.gradeList.push({
                        text: vm.gradeItems[i].grddesc,
                        code: vm.gradeItems[i].grdcode,
                        value: vm.gradeItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        loadJob(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/job/notdisable'
            })
            .then(res => {

                vm.jobItems = res.data.rec;

                for (let i = 0; i < vm.jobItems.length; i++) {
                    vm.jobList.push({
                        text: vm.jobItems[i].jobtitle,
                        code: vm.jobItems[i].jobcode,
                        value: vm.jobItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },


        loadWfdueactions() {
            const vm = this;

            this.$store.dispatch('get', {url: "/wfdueaction/all"}).then(res => {
                vm.wfdueactions = res.data.rec;

                for (let i = 0; i < vm.wfdueactions.length; i++) {
                    vm.wfdueactionList.push({
                        text: vm.wfdueactions[i].wfdueaction,
                        value: vm.wfdueactions[i].id,
                    });
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        changeCompanyHandler(id) {
            if (id) {
                this.allowSave = true;
            } else {
                this.allowSave = false;
            }
            this.isErr = false;

            let item = this.companies.find((item) => item.id == id);

            if (item == undefined) {
                this.selections[0].compnycode = null;
                this.selections[0].compnyname = null;
            } else {
                this.selections[0].compnycode = item.compnycode;
                this.selections[0].compnyname = item.compnyname;
            }
        },

        changeBranchHandler(id){
            let item = this.branchItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].brchcode = null;
                this.selections[0].brchname = null;
            } else {
                this.selections[0].brchcode = item.brchcode;
                this.selections[0].brchname = item.brchname;
            }
        },

        changeDepartmentHandler(id){
            let item = this.departmentItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].deptcode = null;
                this.selections[0].deptname = null;
            } else {
                this.selections[0].deptcode = item.deptcode;
                this.selections[0].deptname = item.deptname;
            }
        },

        changeDivisionHandler(id){
            let item = this.divisionItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].divncode = null;
                this.selections[0].divnname = null;
            } else {
                this.selections[0].divncode = item.divncode;
                this.selections[0].divnname = item.divnname;
            }
        },

        changeSectionHandler(id){
            let item = this.sectionItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].sectiocode = null;
                this.selections[0].sectioname = null;
            } else {
                this.selections[0].sectiocode = item.sectiocode;
                this.selections[0].sectioname = item.sectioname;
            }
        },

        changeUnitHandler(id){
            let item = this.unitItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].unitcode = null;
                this.selections[0].unitname = null;
            } else {
                this.selections[0].unitcode = item.unitcode;
                this.selections[0].unitname = item.unitname;
            }
        },

        changeEmpTypeHandler(id){
            let item = this.emptypeItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].emptype = null;
                this.selections[0].emptypedesc = null;
            } else {
                this.selections[0].emptype = item.emptype;
                this.selections[0].emptypedesc = item.emptypedesc;
            }
        },

        changeGradeHandler(id){
            let item = this.gradeItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].grdcode = null;
                this.selections[0].grddesc = null;
            } else {
                this.selections[0].grdcode = item.grdcode;
                this.selections[0].grddesc = item.grddesc;
            }
        },

        changeJobHandler(id){
            let item = this.jobItems.find(item => item.id == id);

            if (item == undefined) {
                this.selections[0].jobcode = null;
                this.selections[0].jobtitle = null;
            } else {
                this.selections[0].jobcode = item.jobcode;
                this.selections[0].jobtitle = item.jobtitle;
            }
        },


        changeWfdueactionHandler(id) {
            this.isErr = false;

            let item = this.wfdueactions.find((item) => item.id == id);

            this.selections[0].wfdueaction = item.wfdueaction;
        },

        loadLevels() {
            const vm = this;

            for (let i = 1; i < 6; i++) {
                vm.levelList.push({
                    text: i,
                    value: i,
                })
            }
        },

        loadRoles() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/workflowrole/active/all/'
            })
            .then(res => {

                vm.roleItems = res.data.rec;

                for (let i = 0; i < vm.roleItems.length; i++) {
                    vm.roleList.push({
                        text: vm.roleItems[i].role,
                        code: vm.roleItems[i].roledesc,
                        value: vm.roleItems[i].id,
                    });
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        loadMechanism() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/mechanism/all'
            })
            .then(res => {

                vm.mechanismItems = res.data.rec;

                for (let i = 0; i < vm.mechanismItems.length; i++) {
                    vm.mechanismList.push({
                        text: vm.mechanismItems[i].label,
                        code: vm.mechanismItems[i].code,
                        value: vm.mechanismItems[i].id,
                    });
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        loadRoleLevels() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/rolelevel/all'
            })
            .then(res => {

                vm.roleLevelItems = res.data.rec;

                for (let i = 0; i < vm.roleLevelItems.length; i++) {
                    const primaryRole = vm.roleList.find(role => role.value === vm.roleLevelItems[i].primaryroleid);
                    const secondaryRole = vm.roleList.find(role => role.value === vm.roleLevelItems[i].secondaryroleid);
                    const mechanism = vm.mechanismList.find(mech => mech.value === vm.roleLevelItems[i].mechanismid);

                    vm.roleLevelList.push({
                        id: vm.roleLevelItems[i].id,
                        wfsetupdid: vm.roleLevelItems[i].wfsetupdid,
                        levelNo: vm.roleLevelItems[i].levelno,
                        primaryRole: vm.roleLevelItems[i].primaryroleid,
                        primaryRoleText: primaryRole ? primaryRole.text : null,
                        primaryRoleCode: primaryRole ? primaryRole.code : null,
                        secondaryRole: vm.roleLevelItems[i].secondaryroleid,
                        secondaryRoleText: secondaryRole ? secondaryRole.text : null,
                        secondaryRoleCode: secondaryRole ? secondaryRole.code : null,
                        mechanism: vm.roleLevelItems[i].mechanismid,
                        mechanismText: mechanism ? mechanism.text : null,
                        mechanismCode: mechanism ? mechanism.code : null,
                    });
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },
    },

    created() {
        this.loadCompanies();
        this.loadBranch();
        this.loadDivisionHandler();
        this.loadDepartment();
        this.loadSection();
        this.loadUnit();
        this.loadGrade();
        this.loadJob();
        this.loadEmpType();
        this.loadLevels();
        this.loadWfdueactions();
        this.loadRoles();
        this.loadMechanism();
        this.loadRoleLevels();
    }
};
</script>
